<template>
  <div class="dashboard-container">
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        bottom
    >
      <div class="d-flex align-center">
        <v-icon left :color="snackbar.iconColor">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
            :color="snackbar.iconColor"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <div class="dashboard-header">
      <div class="header-content">
        <div class="d-flex align-center">
          <div class="icon-wrapper">
            <v-icon color="#023449" size="28">mdi-chart-box-outline</v-icon>
          </div>
          <div class="ml-3">
            <h1 class="dashboard-title">Gestão de Perdas de Estoque</h1>
            <p class="dashboard-subtitle">Acompanhamento e análise de inventários diários</p>
          </div>
        </div>
      </div>
      <div class="header-actions">
<!--        <export-to-excel-->
<!--            v-if="tableData && tableData.length > 0 && false"-->
<!--            :data="tableData"-->
<!--            :disabled="loading"-->
<!--            file-name="analise_rotativos"-->
<!--        />-->
        <v-btn
            color="#023449"
            dark
            class="action-btn"
            small
            @click="loadDashboardData"
            :loading="loading"
        >
          <v-icon left small>mdi-refresh</v-icon>
          Atualizar
        </v-btn>
      </div>
    </div>
    <div class="filters-wrapper">
      <DashboardFilters
          :filiais="filiaisFiltro"
          :categorias="categoriasFiltro"
          :tipos-lancamento="tiposLancamento"
          :marcas="fabricantesFiltro"
          :loading="loading"
          @filter-change="handleFilterChange"
      />
    </div>

    <div class="dashboard-content">
      <div class="metrics-section">
        <div class="section-header">
          <h2 class="section-title">
            <v-icon color="#023449" size="20" class="mr-2">mdi-chart-line</v-icon>
            Métricas Principais
          </h2>
          <v-chip
              v-if="tableData"
              color="#e8f5e9"
              text-color="#2e7d32"
              small
              class="status-chip"
          >
            <v-icon left x-small color="#2e7d32">mdi-clock-outline</v-icon>
            <span class="text-caption"> Última Atualização {{ lastUpdate }}</span>
          </v-chip>
        </div>
        <div class="metrics-row">
          <MetricCard
              :loading="loading"
              title="rotativos lançados / realizados"
              :value="`${metrics.totalLancamentos} / ${metrics.totalLancamentosRealizados}`"
              icon="mdi-file-document-multiple-outline"
              :trend="metrics.percentualLancamentos ? `${metrics.percentualLancamentos.toFixed(2)}%` : ''"
              :trendType="metrics.trendTypeLancamentos"
          />
          <MetricCard
              :loading="loading"
              title="SKUs Monitorados / Divergentes"
              :value="`${metrics.produtosMonitorados} / ${metrics.produtosUnicosDivergentes}`"
              icon="mdi-package-variant-closed"
              :trend="metrics.percentualProdutosDivergentes ? `${metrics.percentualProdutosDivergentes.toFixed(2)}%` : ''"
              :trendType="metrics.trendTypeProdutosDivergentes"
          />
          <MetricCard
              :loading="loading"
              title="Valor de Divergências"
              :value="`${formataDinheiro(metrics.totalValorDivergencias)}`"
              icon="mdi-cash-multiple"
              :valueColor="metrics.totalValorDivergencias < 0 ? 'attention' : ''"
          />
          <MetricCard
              :loading="loading"
              title="Percentual de Divergências"
              :value="metrics.percentualDivergenciaEstoque ? `${metrics.percentualDivergenciaEstoque.toFixed(2)}%` : '0%'"
              icon="mdi-percent"
              :valueColor="metrics.percentualDivergenciaEstoque < 0 ? 'attention' : ''"
          />
        </div>
      </div>

      <div class="table-section">
        <div class="section-header">
          <h2 class="section-title">
            <v-icon color="#023449" size="20" class="mr-2">mdi-table</v-icon>
            Registros Detalhados
          </h2>

          <!-- Seletor de Visualização -->
          <div class="view-selector">
            <v-btn-toggle
                v-model="activeView"
                color="#023449"
                mandatory
                dense
            >
              <v-btn small value="filiais">
                <v-icon left small>mdi-office-building</v-icon>
                Por Filiais
              </v-btn>
              <v-btn small value="produtos">
                <v-icon left small>mdi-package-variant</v-icon>
                Por Produtos
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>

        <!-- Conteúdo das Visualizações -->
        <div v-if="tableData">
          <!-- Visualização por Filiais -->
          <DataTable
              v-if="activeView === 'filiais'"
              :data="tableData"
              :data_totais="tableDataTotais"
              :filters="currentFilters"
              :loading="loading"
          />

          <!-- Visualização por Produtos -->
          <ProductView
              v-if="activeView === 'produtos'"
              :data="tableData"
              :filters="currentFilters"
              :loading="loading"
          />
        </div>

        <!-- Mensagem quando não há dados -->
        <div v-else class="no-data-message">
          <v-icon size="64" color="#cbd5e1">mdi-inbox</v-icon>
          <h3>Nenhum registro encontrado</h3>
          <p>Ajuste os filtros ou clique em "Atualizar" para visualizar dados</p>
        </div>
      </div>

      <div class="charts-section" v-if="false">
        <div class="section-header">
          <h2 class="section-title">
            <v-icon color="#023449" size="20" class="mr-2">mdi-chart-timeline-variant</v-icon>
            Análise Temporal
          </h2>
          <div class="period-selector">
            <v-btn-toggle
                v-model="selectedPeriod"
                color="#023449"
                mandatory
                dense
            >
              <v-btn small value="15">15 dias</v-btn>
              <v-btn small value="30">30 dias</v-btn>
              <v-btn small value="60">60 dias</v-btn>
            </v-btn-toggle>
          </div>
        </div>
        <div class="charts-grid">
          <div class="chart-wrapper full-width">
            <ChartCard title="Evolução de Lançamentos por Período">
              <TimeSeriesChart :data="timeSeriesData" :filters="currentFilters" />
            </ChartCard>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import DashboardFilters from './Widgets/Filters/DashboardFilters.vue';
import MetricCard from './Widgets/Charts/MetricCard.vue';
import ChartCard from './Widgets/Charts/ChartCard.vue';
import TimeSeriesChart from './Widgets/Charts/TimeSeriesChart.vue';
import FiliaisView from './Widgets/Tables/FiliaisView.vue';
import ProdutosView from './Widgets/Tables/ProdutosView.vue';
// import ExportToExcel from './Widgets/Utils/ExportToExcel.vue';
import {mapState} from "vuex";
import mixinFilial from "../../util/mixinFilial";
import mixinSecao from "../../util/mixinSecao";
import mixinFabricante from "../../util/mixinFabricante";
import axios from "axios";

export default {
  name: 'Dashboard',
  mixins: [mixinFilial, mixinSecao, mixinFabricante],
  components: {
    DashboardFilters,
    MetricCard,
    ChartCard,
    TimeSeriesChart,
    DataTable: FiliaisView,
    ProductView: ProdutosView,
    // ExportToExcel
  },

  data() {
    return {
      loading: false,
      selectedPeriod: '30',
      activeView: 'filiais', // 'filiais' ou 'produtos'

      snackbar: {
        show: false,
        message: '',
        color: 'error',
        icon: 'mdi-alert-circle',
        iconColor: 'white',
        timeout: 6000
      },

      currentFilters: {
        dateRange: { start: null, end: null },
        filiais: [],
        categorias: [],
        marcas: [],
        tipoLancamento: { status: null, tipos: null },
      },

      tableData: [],
      tableDataTotais: {},

      metrics: {
        totalLancamentos: 0,
        totalLancamentosRealizados: 0,
        produtosMonitorados: 0,
        totalProdutos: 0,
        produtosUnicosDivergentes: 0,
        totalValorDivergencias: 0,
        divergencias: 0,
        percentualDivergenciaEstoque: null,
        percentualProdutosDivergentes: null,
        trendTypeLancamentos: null,
        trendTypeProdutosDivergentes: null,
      },

      timeSeriesData: [],
      lastUpdate: new Date().toLocaleString('pt-BR'),

      tiposLancamento: []
    };
  },

  mounted() {
    this.loadTipoLancamentos();
    this.loadDashboardData();
  },

  methods: {
    showSnackbar(message, type = 'error') {
      const config = {
        error: {
          color: 'error',
          icon: 'mdi-alert-circle',
          iconColor: 'white'
        },
        success: {
          color: 'success',
          icon: 'mdi-check-circle',
          iconColor: 'white'
        },
        warning: {
          color: 'warning',
          icon: 'mdi-alert',
          iconColor: 'white'
        },
        info: {
          color: 'info',
          icon: 'mdi-information',
          iconColor: 'white'
        }
      };

      const selectedConfig = config[type] || config.error;

      this.snackbar = {
        show: true,
        message: message,
        color: selectedConfig.color,
        icon: selectedConfig.icon,
        iconColor: selectedConfig.iconColor,
        timeout: type === 'error' ? 8000 : 6000
      };
    },

    handleSessionExpired() {
      this.showSnackbar('Sessão expirou! A página será recarregada em 5 segundos...', 'warning');

      setTimeout(() => {
        window.location.reload();
      }, 5000);
    },

    handleFilterChange(filters) {
      this.currentFilters = { ...filters };
      this.loadDashboardData();
    },

    loadTimeSeriesData() {
      const days = parseInt(this.selectedPeriod);
      this.timeSeriesData = Array.from({ length: days }, (_, i) => ({
        data: new Date(Date.now() - (days - i) * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        lancamentos: Math.floor(Math.random() * 50) + 20,
        divergencias: Math.floor(Math.random() * 5)
      }));
    },

    updateMetrics() {
      let totalDivergencias = 0;
      let totalProdutos = this.tableDataTotais.quantidadeSkus || 0;
      let totalValorDivergencias = this.tableDataTotais.valorDivergencia || 0;
      let percentualDivergenciaEstoque = this.tableDataTotais.percentualDivergencia || 0;
      // let totalValorEstoqueAnterior = this.tableDataTotais.valorEstoqueAnterior || 0;
      // let totalValorEstoqueContado = this.tableDataTotais.valorEstoqueContado || 0;
      let totalLancamentos = this.tableDataTotais.quantidadeLancamentos || 0;
      let totalLancamentosRealizados = this.tableDataTotais.quantidadeLancamentosRealizados || 0;

      const produtosUnicos = new Set();
      const produtosUnicosDivergentes = new Set();

      this.tableData.forEach(filial => {
        filial.dias.forEach(dia => {
          dia.produtos.forEach(produto => {
            produtosUnicos.add(produto.codigo);
            // totalProdutos++;

            if (produto.diferencaQuantidade !== 0 || produto.diferencaValor !== 0) {
              totalDivergencias++;
              produtosUnicosDivergentes.add(produto.codigo);
              // totalValorDivergencias += produto.diferencaValor;
            }
          });
        });
      });

      const percentualLancamentos = totalLancamentos > 0
          ? parseFloat(((totalLancamentosRealizados / totalLancamentos) * 100).toFixed(1))
          : 0;

      const percentualProdutosDivergentes = produtosUnicos.size > 0
          ? parseFloat(((produtosUnicosDivergentes.size / produtosUnicos.size) * 100).toFixed(1))
          : 0;

      this.metrics = {
        totalLancamentos: totalLancamentos,
        totalLancamentosRealizados: totalLancamentosRealizados,
        produtosMonitorados: produtosUnicos.size,
        totalProdutos: totalProdutos,
        divergencias: totalDivergencias,
        produtosUnicosDivergentes: produtosUnicosDivergentes.size,
        totalValorDivergencias: totalValorDivergencias,
        percentualProdutosDivergentes: percentualProdutosDivergentes,
        percentualLancamentos: percentualLancamentos,

        percentualDivergenciaEstoque: percentualDivergenciaEstoque,

        trendTypeLancamentos: percentualLancamentos >= 90 ? 'good' : percentualLancamentos >= 70 ? 'neutral' : 'attention',
        trendTypeProdutosDivergentes: percentualProdutosDivergentes <= 10 ? 'good' : percentualProdutosDivergentes <= 20 ? 'neutral' : 'attention',
      };
    },

    async loadDashboardData() {

      try {
        this.loading = true;

        const response = await axios.post(`${this.backendUrl}dashboard/rotativo/listar`, {
          idempresa: this.currentFilters.filiais.join(',') || null,
          idsecao: this.currentFilters.categorias.join(',') || null,
          idmarca: this.currentFilters.marcas.join(',') || null,
          dtini: this.currentFilters.dateRange?.start || null,
          dtfim: this.currentFilters.dateRange?.end || null,
          idtipos: this.currentFilters.tipoLancamento.tipos?.join(',') || null,
          idstatus: this.currentFilters.tipoLancamento.status || 1,
        });

        // Verificar se há erro de token inválido
        if (response.data && response.data.erro) {
          const erroMsg = response.data.erro.trim().toLowerCase();

          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            return;
          }

          // Outros tipos de erro
          this.showSnackbar(`Erro: ${response.data.erro}`, 'error');
          this.tableData = [];
          this.updateMetrics();
          return;
        }

        if (response.data) {
          this.tableData = response.data.empresas || [];
          this.tableDataTotais = response.data.totalizadorGeral || null;

          this.updateMetrics();

          if (response.data.timeSeriesData) {
            this.timeSeriesData = response.data.timeSeriesData;
          } else {
            this.loadTimeSeriesData();
          }

          this.lastUpdate = new Date().toLocaleString('pt-BR');
        } else {
          this.tableData = [];
          this.updateMetrics();
        }

      } catch (error) {
        if (error.response) {
          const status = error.response.status;
          const errorData = error.response.data;

          if (errorData && errorData.erro) {
            const erroMsg = errorData.erro.trim().toLowerCase();

            if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
              this.handleSessionExpired();
              return;
            }
          }

          if (status === 401 || status === 403) {
            this.handleSessionExpired();
          } else if (status === 404) {
            this.showSnackbar('Serviço não encontrado. Verifique a URL da API.', 'error');
          } else if (status === 500) {
            this.showSnackbar('Erro interno do servidor. Tente novamente mais tarde.', 'error');
          } else {
            this.showSnackbar(`Erro ao carregar dados: ${errorData?.erro || error.message}`, 'error');
          }
        } else if (error.request) {
          this.showSnackbar('Erro de conexão. Verifique sua internet e tente novamente.', 'error');
        } else {
          this.showSnackbar('Ocorreu um erro inesperado. Tente novamente.', 'error');
        }

        this.tableData = [];
        this.updateMetrics();
      } finally {
        this.loading = false;
      }
    },

    async loadTipoLancamentos() {
      try {
        this.loading = true;

        const response = await axios.post(`${this.backendUrl}dashboard/rotativo/tipo/listar`, {});

        // Verificar se há erro de token inválido
        if (response.data && response.data.erro) {
          const erroMsg = response.data.erro.trim().toLowerCase();

          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            return;
          }

          // Outros tipos de erro
          this.showSnackbar(`Erro: ${response.data.erro}`, 'error');
          this.tiposLancamento = [];

          return;
        }

        if (response.data) {
          this.tiposLancamento = response.data || [];
        } else {
          this.tiposLancamento = [];
        }

      } catch (error) {
        if (error.response) {
          const status = error.response.status;
          const errorData = error.response.data;

          if (errorData && errorData.erro) {
            const erroMsg = errorData.erro.trim().toLowerCase();

            if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
              this.handleSessionExpired();
              return;
            }
          }

          if (status === 401 || status === 403) {
            this.handleSessionExpired();
          } else if (status === 404) {
            this.showSnackbar('Serviço não encontrado. Verifique a URL da API.', 'error');
          } else if (status === 500) {
            this.showSnackbar('Erro interno do servidor. Tente novamente mais tarde.', 'error');
          } else {
            this.showSnackbar(`Erro ao carregar dados: ${errorData?.erro || error.message}`, 'error');
          }
        } else if (error.request) {
          this.showSnackbar('Erro de conexão. Verifique sua internet e tente novamente.', 'error');
        } else {
          this.showSnackbar('Ocorreu um erro inesperado. Tente novamente.', 'error');
        }

        this.tableData = [];
        this.updateMetrics();
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    ...mapState(["backendUrl", "usuario"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 4 &&
              v.idfilial !== 6 &&
              v.idfilial !== 13 &&
              v.idfilial !== 28 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37 &&
              v.idfilial !== 40 &&
              v.idfilial !== 42
          );
        });
      } else {
        return [];
      }
    },
    categoriasFiltro() {
      if (this.secoes.lista) {
        return this.secoes.lista.filter((v) => {
          return (
              v.idsecao !== 1
          );
        });
      } else {
        return [];
      }
    },
    fabricantesFiltro() {
      if (this.fabricantes.lista) {
        return this.fabricantes.lista.filter((v) => {
          return (
              v.idfabricante !== 1
          );
        });
      } else {
        return [];
      }
    },
  },

  watch: {
    selectedPeriod() {
      this.loadTimeSeriesData();
    }
  }
};
</script>

<style scoped>
.dashboard-container {
  min-height: 100vh;
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 0 8px 8px 8px;
}

/* Header Section */
.dashboard-header {
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
  background: #ffffff;
  border-radius: 12px;
}

.header-content {
  flex: 1;
}

.icon-wrapper {
  background: linear-gradient(135deg, rgba(2, 52, 73, 0.08) 0%, rgba(2, 52, 73, 0.04) 100%);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #023449;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.dashboard-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 4px 0 0 0;
  font-weight: 400;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 8px;
  padding: 0 20px !important;
}

/* Filters Wrapper */
.filters-wrapper {
  padding: 20px 0;
}

/* Main Content */
.dashboard-content {
  padding: 20px 0 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* Section Styling */
.metrics-section,
.charts-section,
.table-section {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #023449;
  margin: 0;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
}

.status-chip {
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Metrics Row */
.metrics-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

/* View Selector */
.view-selector {
  display: flex;
  align-items: center;
}

.view-selector >>> .v-btn-toggle {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
}

.view-selector >>> .v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 0.813rem;
  color: #64748b;
  border-radius: 0 !important;
  padding: 0 16px !important;
  height: 36px !important;
}

.view-selector >>> .v-btn--active {
  background-color: #023449 !important;
  color: #ffffff !important;
}

.view-selector >>> .v-btn:not(.v-btn--active):hover {
  background-color: rgba(2, 52, 73, 0.04);
}

.view-selector >>> .v-btn .v-icon {
  color: inherit;
}

/* Period Selector */
.period-selector >>> .v-btn-toggle {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.period-selector >>> .v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 0.813rem;
  color: #64748b;
  border-radius: 0 !important;
}

.period-selector >>> .v-btn--active {
  background-color: #023449 !important;
  color: #ffffff !important;
}

.period-selector >>> .v-btn:not(.v-btn--active):hover {
  background-color: rgba(2, 52, 73, 0.04);
}

/* Charts Grid */
.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.chart-wrapper.full-width {
  grid-column: 1 / -1;
}

/* Tables Section */

/* No Data Message */
.no-data-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 16px;
  padding: 40px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.no-data-message h3 {
  margin: 0;
  color: #023449;
  font-size: 1.25rem;
  font-weight: 700;
}

.no-data-message p {
  color: #64748b;
  font-size: 0.875rem;
  margin: 0;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-header {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }

  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    padding-left: 20px;
    padding-right: 20px;
  }

  .dashboard-title {
    font-size: 1.25rem;
  }

  .dashboard-subtitle {
    font-size: 0.813rem;
  }

  .metrics-row {
    grid-template-columns: 1fr;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .header-actions {
    flex-direction: column;
    width: 100%;
  }

  .action-btn {
    width: 100%;
  }

  .view-selector {
    width: 100%;
    margin-top: 12px;
  }

  .view-selector >>> .v-btn-toggle {
    width: 100%;
  }

  .view-selector >>> .v-btn {
    flex: 1;
  }
}

@media (max-width: 480px) {
  .dashboard-title {
    font-size: 1.125rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .icon-wrapper {
    padding: 10px;
  }

  .icon-wrapper >>> .v-icon {
    font-size: 24px !important;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .metrics-section,
  .charts-section,
  .table-section {
    animation: none !important;
  }
}

/* Tablets - 2 cards por linha */
@media (max-width: 1440px) {
  .metrics-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile - 1 card por linha */
@media (max-width: 700px) {
  .metrics-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>